// @flow
import React, { Component } from 'react';
import FloatHeart from './FloatHeart';

class AnimatedHeart extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.node = React.createRef();
  }


  generateUUID = () => {
    // Public Domain/MIT
    // Timestamp
    let d = new Date().getTime();

    // Time in microseconds since page-load or 0 if unsupported
    let d2 = (performance && performance.now && performance.now() * 1000) || 0;

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, ( c ) => {
      // random number between 0 and 16
      let r = Math.random() * 16;

      if (d > 0) {
        // Use timestamp until depleted
        r = (d + r) % 16 | 0;
        d = Math.floor(d / 16);
      } else {
        // Use microseconds since page-load if supported
        r = (d2 + r) % 16 | 0;
        d2 = Math.floor(d2 / 16);
      }
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  };

  splash = () => {
    // x,y heart initial location
    // x1, y1 start point related to x,y
    // x2, y2 end point releated to x,y

    const { x, y } = this.node.current.getClientRects()[0];

    const x1 = this.props.deltaX || 0;
    const y1 = this.props.deltaY || 0;
    const r = this.props.radius || 60;
    const count = this.props.count || 5;
    const fixed = this.props.fixed || false;

    let array = {};

    for (let i = 0; i < count; i++) {
      let uuid = this.generateUUID();

      const radius = r + Math.floor(Math.random() * r / 2);
      const radian = Math.random() * Math.PI * 2;
      const x2 = radius * Math.sin(radian) + x1;
      const y2 = radius * Math.cos(radian) + y1;

      array[uuid] = <FloatHeart key={uuid} x1={x1} y1={y1} x2={x2} y2={y2} x={x} y={y} fixed={fixed} />;

      setTimeout(
        function(uuid) {
          this.setState({ [uuid]: undefined });
        }.bind(this),
        3000,
        uuid
      );
    }

    this.setState({ ...array });

  };

  render() {
    const divStyle = {
      width: 0,
      height: 0
    };

    const listItems = Object.values(this.state);

    return (
      <div ref={this.node} style={divStyle}>{listItems}</div>
    );
  }
}

export default AnimatedHeart;
